/* @ngInject */
function CostFactory($http, $rootScope) {
  class Cost {
    constructor(data) {
      if (data) angular.extend(this, data);
    }

    static getResourceUrl() {
      return `${process.env.SERVER_URL}/api/secure/organization/${$rootScope.organization.slug}/costs`;
    }

    isNew() {
      return !this._id;
    }

    setDataFromCostSnapshot(costSnapshotData) {
      this.name = costSnapshotData.name;
      this.unit = costSnapshotData.unit;
      this.price = costSnapshotData.price;
      this.currency = costSnapshotData.currency;
      this.amount = costSnapshotData.amount;
      this.comments = costSnapshotData.comments;
    }

    canMove(destinationCostFolder) {
      // Si la carpeta de destino es la raiz y ya esta en la carpeta raiz
      if (destinationCostFolder === null && this.parent === null) return false;

      // Si no es la misma carpeta
      const parentId = this.parent && this.parent._id ? this.parent._id : null;
      return parentId !== destinationCostFolder._id;
    }

    static query(params) {
      return $http
        .get(Cost.getResourceUrl(), { params })
        .then((response) => response.data.map((costData) => new Cost(costData)));
    }

    static getCount(params) {
      return $http.get(`${Cost.getResourceUrl()}/count`, { params }).then((response) => response.data);
    }

    static queryByParent(parentId, page) {
      return $http
        .get(Cost.getResourceUrl(), {
          params: { parent: parentId || "null", page: page },
        })
        .then((response) => response.data.map((costData) => new Cost(costData)));
    }

    static importCsv(fromDataFile) {
      return $http
        .post(`${Cost.getResourceUrl()}/import-csv`, fromDataFile, {
          headers: { "Content-Type": undefined },
        })
        .then(() => true);
    }

    save() {
      return this.isNew() ? this.create() : this.update();
    }

    create() {
      if (!this.isNew()) throw new Error("The cost is already created");

      return $http.post(Cost.getResourceUrl(), this).then((response) => angular.extend(this, response.data));
    }

    update() {
      if (this.isNew()) throw new Error("Can not update a cost that has not been created");

      return $http
        .put(`${Cost.getResourceUrl()}/${this._id}`, this)
        .then((response) => angular.extend(this, response.data));
    }

    move(parent) {
      if (this.isNew()) throw new Error("Can not move a cost that has not been created");

      return $http
        .put(`${Cost.getResourceUrl()}/${this._id}/move`, { parent })
        .then((response) => angular.extend(this, response.data));
    }

    delete() {
      if (this.isNew()) throw new Error("Can not delete a cost that has not been created");

      return $http.delete(`${Cost.getResourceUrl()}/${this._id}`).then(() => true);
    }
  }

  return Cost;
}

export default CostFactory;
